<template>
	<el-card v-show="medication.length > 0">
		<div slot="header" class="medication header">
			<img src="../image/medication_new.png" class="header-icon">
			<span class="header-title">Medications</span>
		</div>
		<MedicationTable :patient="patient"
			v-bind:medication="activeMedication"
			v-bind:compliance="compliance"
			v-bind:dose="dose">
		</MedicationTable>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import MedicationTable from './Table'

export default {
	name: 'patient-medication-card',
	extends: OverviewCard,

	computed: {
		medication() {
			return this.patientEventType('medication')
		},
		compliance() {
			return this.patientEventType('compliance')
		},
		dose() {
			return this.patientEventType('dose')
		},
		activeMedication() {
			return this.medication.filter((medication) => !medication.archived)
		},
		archivedMedication() {
			return this.medication.filter((medication) => medication.archived)
		}
	},

	components: {
		MedicationTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.header-icon {
	height: 40px !important;
}
</style>
